import {
  Modal,
  ModalClose,
  ModalPrimaryActionButton,
  ModalTertiaryActionButton,
} from '@la/ds-ui-components';
import styles from './RemoveFromCartModal.module.scss';

export type RemoveFromCartModalProps = {
  cancelActionLabel?: string;
  closeModal: () => void;
  isOpen: boolean;
  isProcessing?: boolean;
  mainMessage?: string;
  modalTitle?: string;
  primaryActionLabel?: string;
  removeCartItem: () => void;
  secondaryMessage?: string;
};

/* RemoveFromCartModal */
export default function RemoveFromCartModal({
  cancelActionLabel = 'Cancel',
  closeModal,
  isOpen,
  isProcessing = false,
  mainMessage,
  modalTitle = 'Remove item',
  primaryActionLabel = 'Yes, remove this',
  removeCartItem,
  secondaryMessage,
}: RemoveFromCartModalProps) {
  return (
    <Modal
      hideClose={false}
      onOpenChange={closeModal}
      open={isOpen}
      primaryAction={
        <ModalPrimaryActionButton
          onClick={removeCartItem}
          loading={isProcessing}
        >
          {primaryActionLabel}
        </ModalPrimaryActionButton>
      }
      size="small"
      tertiaryAction={
        <ModalClose>
          <ModalTertiaryActionButton>
            {cancelActionLabel}
          </ModalTertiaryActionButton>
        </ModalClose>
      }
      title={modalTitle}
    >
      <div className={styles.modalContent}>
        {mainMessage}
        {secondaryMessage ? (
          <div className={styles.confirmSentence}>{secondaryMessage}</div>
        ) : null}
      </div>
    </Modal>
  );
}
/* */
